import React, { useEffect, useState } from 'react';
import ListContainer from '../components/ListContainer';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useCreateUpdateProject2Mutation,
  useGetProjectByIdToEditQuery,
} from '../slices/projectsApiSlice';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@mui/material';
import Alerton from '../components/Alerton';
import { financingCode } from '../utils/financing';

const ProjectEditScreenV2 = () => {
  const navigate = useNavigate();
  const [isEscrowDisclosed, setIsEscrowDisclosed] = useState(false);
  const [isEscrowDisclosureDocumentsSubmitted, setIsEscrowDisclosureDocumentsSubmitted] = useState(false);
  const { section, id } = useParams();
  const [header, setHeader] = useState('');
  const [title, setTitle] = useState('');
  const [color1, setColor1] = useState('');
  const [color2, setColor2] = useState('');
  const [color3, setColor3] = useState('');
  const [color4, setColor4] = useState('');
  const [note, setNote] = useState('');

  const [description, setDescription] = useState('');
  const [financingType, setFinancingType] = useState('');
  const [paidInitialPayment, setPaidInitialPayment] = useState(false);
  const [hasLandPlot, setHasLandPlot] = useState(false);
  const [plannedOccupants, setPlannedOccupants] = useState(0);
  const [childrenCount, setChildrenCount] = useState(0);

  const [projectName, setProjectName] = useState('');
  const [initialPaymentSource, setInitialPaymentSource] = useState('');
  const [buildingProject, setBuildingProject] = useState('');
  const [phones, setPhones] = useState('');
  const [kadastr, setKadastr] = useState('');
  const [referrer, setReferrer] = useState('');
  const [period, setPeriod] = useState('');
  const [leadSource, setLeadSource] = useState('');
  const [region, setRegion] = useState('');
  const [equipment, setEquipment] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedManager, setSelectedManager] = useState('');
  const [requiredFields, setRequiredFields] = useState([]);
  //const { data, refetch, isLoading, isError } = useGetTypesQuery();
  const { data, isLoading, isError, error } = useGetProjectByIdToEditQuery(id);
  const financeOptions = data?.financingTypes || [];
  const selectedFinance = financeOptions.find((item) => item._id === financingType);
  const isMortgage = financingCode(selectedFinance) === 'mortgage';

  // console.log('ProjectEditScreenV2.jsx data', data);

  const [createUpdateProject] = useCreateUpdateProject2Mutation();
  const [message, setMessage] = useState('');
  const handleCloseMessage = () => {
    setMessage('');
  };

  const handleChangeField = (value, field) => {
    switch (field) {
      case 'hasLandPlot':
        setHasLandPlot(value);
        break;
      case 'paidInitialPayment':
        setPaidInitialPayment(value);
        break;
      case 'plannedOccupants':
        setPlannedOccupants(value);
        break;
      case 'childrenCount':
        setChildrenCount(value);
        break;
      default:
        break;
    }
  };

  const handleChangeType = (event) => {
    setSelectedType(event.target.value);
  };
  const handleChangeEquipment = (event) => {
    setEquipment(event.target.value);
  };
  const handleChangeLeadSource = (event) => {
    setLeadSource(event.target.value);
  };
  const handleChangeRegion = (event) => {
    setRegion(event.target.value);
  };
  // const handleChangeFinancingType = (event) => {
  //   setFinancingType(event.target.value);
  // };
  const handleChangeBuildingProject = (event) => {
    setBuildingProject(event.target.value);
  };
  const handleChangeFinancingType = (event) => {
    const next = event.target.value;
    setFinancingType(next);
    if (financingCode(financeOptions.find((item) => item._id === next)) !== 'mortgage') {
      setIsEscrowDisclosed(false);
      setIsEscrowDisclosureDocumentsSubmitted(false);
    }
  };
  const handleChangeManager = (event) => {
    setSelectedManager(event.target.value);
  };
  const goBack = (_, resid) => {
    // if (resid) {
    //   navigate('.', {
    //     replace: true,
    //     state: {
    //       refetch: true,
    //       action: 'back',
    //       timestamp: Date.now(),
    //     },
    //   });
    //   // navigate(
    //   //   {
    //   //     pathname: '/projects/v2/',
    //   //     //search: `refetch=${true}`,
    //   //   },
    //   //   {
    //   //     state: { refetch: true, id: resid },
    //   //   },
    //   // );
    // } else
    if (id && id !== 'new') {
      navigate(`/crm/${section}/${id}`); // navigate(`/projects/v2/${id}`);
      // navigate(`/projects/v2/${id}`);
    } else {
      navigate(`/crm/${section}/`);
    }
  };

  const goSave = async () => {
    const data = {
      _id: id,
      title: title,
      period: period,
      description: description,
      phones: phones,
      projectName: projectName,
      kadastr: kadastr,
      type: selectedType,
      referrer: referrer,
      manager: selectedManager,
      color1: color1,
      color2: color2,
      color3: color3,
      color4: color4,
      note: note,
      isEscrowDisclosed: isEscrowDisclosed,
      isEscrowDisclosureDocumentsSubmitted: isEscrowDisclosureDocumentsSubmitted,
      leadSource: leadSource,
      region: region,
      buildingProject: buildingProject,
      financingType: financingType,
      paidInitialPayment: paidInitialPayment,
      initialPaymentSource: initialPaymentSource,
      hasLandPlot: hasLandPlot,
      plannedOccupants: plannedOccupants,
      childrenCount: childrenCount,
      equipment: equipment,
    };

    try {
      const res = await createUpdateProject(data).unwrap();
      goBack(null, res?._id);
    } catch (error) {
      console.log(error);
      if (error?.data?.fields && Array.isArray(error.data.fields)) {
        setRequiredFields(error.data.fields);
      }
      setMessage(
        error?.data?.message ||
          error?.data?.error ||
          error?.message ||
          error?.error?.message ||
          error?.error ||
          error ||
          'Ошибка при сохранении проекта',
      );
    }
  };

  useEffect(() => {
    if (id === 'new') {
      setHeader('Новый объект');
      const undecided = data?.financingTypes?.find((item) => financingCode(item) === 'undecided');
      if (undecided) setFinancingType(undecided._id);
      return;
    }

    if (data?.project) {
      const project = data.project;

      // 👇 ObjectId → string
      setSelectedType(project.type?._id || '');
      setSelectedManager(project.manager?._id || '');
      setLeadSource(project.leadSource?._id || '');
      setRegion(project.region?._id || '');
      setBuildingProject(project.buildingProject?._id || '');
      setFinancingType(project.financingType?._id || data?.financingTypes?.find((item) => financingCode(item) === 'undecided')?._id || '');
      setEquipment(project.equipment?._id || '');

      // 👇 Primitive значения
      setTitle(project.title || '');
      setDescription(project.description || '');
      setProjectName(project.projectName || '');
      setPhones(project.phones || '');
      setKadastr(project.kadastr || '');
      setReferrer(project.referrer || '');
      setPeriod(project.period || '');
      setNote(project.note || '');
      setColor1(project.color1 || '');
      setColor2(project.color2 || '');
      setColor3(project.color3 || '');
      setColor4(project.color4 || '');
      setInitialPaymentSource(project.initialPaymentSource || '');

      // 👇 Числа/булевы
      setPlannedOccupants(project.plannedOccupants || 0);
      setChildrenCount(project.childrenCount || 0);
      setHasLandPlot(!!project.hasLandPlot);
      setPaidInitialPayment(!!project.paidInitialPayment);
      setIsEscrowDisclosed(project.isEscrowDisclosed === true);
      setIsEscrowDisclosureDocumentsSubmitted(
        project.isEscrowDisclosureDocumentsSubmitted === true || project.isEscrowDisclosed === true,
      );

      setHeader(project.title);
    }
  }, [id, data]);

  // console.log('selectedType', selectedType); //6911d3689125fb5341a02a5b
  let availableUsers = data?.users || [];

  if (selectedType) {
    availableUsers = availableUsers.filter((user) =>
      user?.types?.includes(selectedType),
    );
  }

  // console.log('financingType', financingType);

  return (
    <>
      <ListContainer goBack={goBack} title={header} addable={false}>
        {isLoading ? (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Box sx={{ display: 'flex' }}>
            <Alert severity='warning'>
              {error?.data?.message || error.error}
            </Alert>
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <strong>Название: </strong>
              <TextField
                error={requiredFields.includes('title')}
                size='small'
                fullWidth
                id='outlined-required'
                value={title || ''}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <strong>Описание (адрес): </strong>
              <TextField
                error={requiredFields.includes('description')}
                size='small'
                fullWidth
                id='outlined-required'
                value={description || ''}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            {/* {data?.regions && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size='small'
                  error={requiredFields.includes('region')}
                >
                  <strong>Регион: </strong>
                  <Select
                    fullWidth
                    value={region}
                    size='small'
                    onChange={handleChangeRegion}
                  >
                    <MenuItem value=''>
                      <em>Не выбран</em>
                    </MenuItem>
                    {data?.regions &&
                      data?.regions.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )} */}
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size='small'
                error={requiredFields.includes('type')}
              >
                <strong>Воронка: </strong>
                <Select
                  fullWidth
                  value={selectedType}
                  size='small'
                  onChange={handleChangeType}
                >
                  <MenuItem value=''>
                    <em>Не выбран</em>
                  </MenuItem>
                  {data?.types &&
                    data.types.map((item, index) => (
                      <MenuItem key={index} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size='small'
                error={requiredFields.includes('manager')}
              >
                <strong>Ответственный: </strong>
                <Select
                  fullWidth
                  value={selectedManager}
                  size='small'
                  onChange={handleChangeManager}
                >
                  <MenuItem value=''>
                    <em>Не выбран</em>
                  </MenuItem>
                  {availableUsers &&
                    availableUsers.map((item, index) => (
                      <MenuItem key={index} value={item._id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size='small'
                error={requiredFields.includes('leadSource')}
              >
                <strong>Источник: </strong>
                <Select
                  fullWidth
                  value={leadSource}
                  size='small'
                  onChange={handleChangeLeadSource}
                >
                  <MenuItem value=''>
                    <em>Не выбран</em>
                  </MenuItem>
                  {data?.leadsources &&
                    data?.leadsources.map((item, index) => (
                      <MenuItem key={index} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <strong>Дополнение к источнику: </strong>
              <TextField
                error={requiredFields.includes('referrer')}
                size='small'
                fullWidth
                value={referrer || ''}
                onChange={(e) => setReferrer(e.target.value)}
              />
            </Grid>
            {data?.buildingProjects && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size='small'
                  error={requiredFields.includes('buildingProject')}
                >
                  <strong>Проект дома: </strong>
                  <Select
                    fullWidth
                    value={buildingProject}
                    size='small'
                    onChange={handleChangeBuildingProject}
                  >
                    <MenuItem value=''>
                      <em>Не выбран</em>
                    </MenuItem>
                    {data?.buildingProjects &&
                      data?.buildingProjects.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12}>
              <strong>Дополнение к проекту: </strong>
              <TextField
                error={requiredFields.includes('projectName')}
                size='small'
                fullWidth
                value={projectName || ''}
                onChange={(e) => setProjectName(e.target.value)}
              />
            </Grid>

            {data?.equipments && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size='small'
                  error={requiredFields.includes('equipment')}
                >
                  <strong>Комплектация: </strong>
                  <Select
                    fullWidth
                    value={equipment || ''}
                    size='small'
                    onChange={handleChangeEquipment}
                  >
                    <MenuItem value=''>
                      <em>Не выбран</em>
                    </MenuItem>
                    {data?.equipments &&
                      data?.equipments.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {data?.financingTypes && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size='small'
                  error={requiredFields.includes('financingType')}
                >
                  <strong>Финансирование: </strong>
                  <Select
                    fullWidth
                    value={financingType || ''}
                    size='small'
                    onChange={handleChangeFinancingType}
                  >
                    <MenuItem value=''>
                      <em>Не выбрано</em>
                    </MenuItem>
                    {data?.financingTypes &&
                      data?.financingTypes.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12}>
              <strong>Первоначальный платеж: </strong>
              <Switch
                onChange={(e) =>
                  handleChangeField(e.target.checked, 'paidInitialPayment')
                }
                checked={paidInitialPayment}
              />
            </Grid>
            {paidInitialPayment &&<Grid item xs={12}>
              <strong>Источник платежа: </strong>
              <TextField
                // error={requiredFields.includes('referrer')}
                size='small'
                fullWidth
                value={initialPaymentSource || ''}
                onChange={(e) => setInitialPaymentSource(e.target.value)}
              />
            </Grid>}
            <Grid item xs={12}>
              <strong>Есть участок: </strong>
              <Switch
                onChange={(e) =>
                  handleChangeField(e.target.checked, 'hasLandPlot')
                }
                checked={hasLandPlot}
              />
            </Grid>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={7}>
                <strong>Кол-во жильцов: </strong>
                <TextField
                  error={requiredFields.includes('plannedOccupants')}
                  size='small'
                  fullWidth
                  value={plannedOccupants || ''}
                  onChange={(e) =>
                    handleChangeField(e.target.value, 'plannedOccupants')
                  }
                />
              </Grid>
              <Grid item xs={5}>
                <strong>из них детей: </strong>
                <TextField
                  size='small'
                  fullWidth
                  value={childrenCount || ''}
                  onChange={(e) =>
                    handleChangeField(e.target.value, 'childrenCount')
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <strong>Срок: </strong>
              <TextField
                error={requiredFields.includes('period')}
                size='small'
                fullWidth
                value={period || ''}
                onChange={(e) => setPeriod(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <strong>Кадастровый номер: </strong>
              <TextField
                error={requiredFields.includes('kadastr')}
                size='small'
                fullWidth
                value={kadastr || ''}
                onChange={(e) => setKadastr(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <strong>Телефон заказчика: </strong>
              <TextField
                error={requiredFields.includes('phones')}
                size='small'
                fullWidth
                value={phones || ''}
                onChange={(e) => setPhones(e.target.value)}
              />
            </Grid>
            {isMortgage && <Grid item xs={12} container alignItems='center' spacing={1}>
              <Grid item>
                <strong>Документы на раскрытие эскроу поданы: </strong>
                <Switch
                  onChange={(e) => setIsEscrowDisclosureDocumentsSubmitted(e.target.checked)}
                  checked={isEscrowDisclosureDocumentsSubmitted}
                  disabled={isEscrowDisclosed}
                  color='warning'
                />
              </Grid>
              <Grid item>
                <strong>Эскроу раскрыт: </strong>
                <Switch
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIsEscrowDisclosed(checked);
                    if (checked) setIsEscrowDisclosureDocumentsSubmitted(true);
                  }}
                  checked={isEscrowDisclosed}
                  color='success'
                />
              </Grid>
            </Grid>}
            <Grid item xs={12}>
              <strong>Кровля: </strong>

              <TextField
                error={requiredFields.includes('color1')}
                size='small'
                fullWidth
                value={color1 || ''}
                onChange={(e) => setColor1(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <strong>Фасад: </strong>

              <TextField
                error={requiredFields.includes('color2')}
                size='small'
                fullWidth
                value={color2 || ''}
                onChange={(e) => setColor2(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <strong>Карниз: </strong>

              <TextField
                error={requiredFields.includes('color3')}
                size='small'
                fullWidth
                value={color3 || ''}
                onChange={(e) => setColor3(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <strong>Окна: </strong>

              <TextField
                error={requiredFields.includes('color4')}
                size='small'
                fullWidth
                value={color4 || ''}
                onChange={(e) => setColor4(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <strong>Комментарий: </strong>

              <TextField
                multiline
                minRows={2}
                maxRows={4}
                size='small'
                fullWidth
                value={note || ''}
                onChange={(e) => setNote(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant='contained' onClick={goSave}>
                Сохранить
              </Button>
            </Grid>
          </Grid>
        )}
      </ListContainer>
      <Alerton message={message} handleCloseMessage={handleCloseMessage} />
    </>
  );
};

export default ProjectEditScreenV2;
